const showHideMobileMenu = () => {

	function toggle(){
		document.querySelector('.header .menu .fence .line1')
			.classList.toggle('rotate');
		document.querySelector('.header .menu .dropdown')
			.classList.toggle('hide', );
		document.querySelector('.header .menu .dropdown')
			.classList.toggle('fadeIn');
	}

	document.querySelector('.header .menu .fence')
		.addEventListener("click", (e)=> {
			toggle();
	});

	document.querySelector('.header .menu .dropdown')
		.addEventListener("click", (e)=> {
			toggle();
		});
}
export default showHideMobileMenu;